export const promises = {};